import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UserSupportingCompanyState } from './user-supporting-company.state';

export const selectUSCState = createFeatureSelector<UserSupportingCompanyState>('userSupportingCompany');

export const selectLoadingCompaniesSupportedByUser = createSelector(
  selectUSCState,
  state => state.loadingCompaniesSupportedByUser
);
export const selectCompaniesSupportedByUser = createSelector(selectUSCState, state => state.companiesSupportedByUser);

export const selectLoadingUsersSupportingCompany = createSelector(
  selectUSCState,
  state => state.loadingUsersSupportingCompany
);
export const selectUsersSupportingCompany = createSelector(selectUSCState, state => state.usersSupportingCompany);

export const selectUpdateInProgress = createSelector(selectUSCState, state => state.updateInProgress);
export const selectErrorMessage = createSelector(selectUSCState, state => state.errorMessage);
